import { HelpersService } from '../../../../../services/helpers.service';
import { inject, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InvoiceOptionsService } from '../../../../../services/invoice-options.service';
import { PaymentService } from '../../../../../services/payment.service';

@Component({
  selector: 'app-jobcard-multi-quote-approval',
  templateUrl: './jobcard-multi-quote-approval.component.html',
  styleUrls: ['./jobcard-multi-quote-approval.component.scss']
})
export class JobcardMultiQuoteApprovalComponent implements OnInit {
  public helpersService = inject(HelpersService);


  @Input() jobCardIdentifier: any

  public serviceIdentifier = "";
  public busy = false;
  public busySubmitting = false;
  public jobcard: any = {};
  public displayRejectAll = false;
  public rejectionFeedback = "";
  public canDoKlarnaPayment = false;

  constructor(
    private invoiceOptionsService: InvoiceOptionsService,
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {

    this.serviceIdentifier = this.route.snapshot.paramMap.get('serviceIdentifier');

    if (this.jobCardIdentifier && !this.serviceIdentifier)
      this.serviceIdentifier = this.jobCardIdentifier;

    console.log(this.jobCardIdentifier);
    console.log(this.serviceIdentifier);


    this.getApprovalOptions();
  }

  getPaymentOptions(partnerID) {
    this.paymentService.checkPartnersStripePaymentOptions(partnerID).subscribe(res => {
      if (res && res.klarna_payments === "active") {
        this.canDoKlarnaPayment = true;
      }
    });
  }

  getApprovalOptions() {
    this.busy = true;
    this.invoiceOptionsService.getCustomerInvoiceOptions(this.serviceIdentifier).subscribe(jobcard => {
      this.jobcard = jobcard;
      console.log(this.jobcard);
      this.setSections();
      this.busy = false;
      this.markOptionsAsSeen();
      this.getPaymentOptions(jobcard.partnerID);
    }, err => {
      this.busy = false;
    });
  }

  // Splits each option's lines into Labour and Parts & Materials, so each option only shows its own sections
  setSections() {
    if (!this.jobcard.quoteOptions) return;

    this.jobcard.quoteOptions.forEach(option => {
      // An option with no lines comes back with null lines
      const lineItems = option.invoiceQuoteOptionLineItem || [];
      option.labourLineItems = lineItems.filter(x => x.isNonInventory);
      option.partsLineItems = lineItems.filter(x => !x.isNonInventory);
      option.labourAmount = this.getSectionAmount(option.labourLineItems);
      option.partsAmount = this.getSectionAmount(option.partsLineItems);
    });
  }

  // Same figures as the job card quote's sections: each line's price × quantity, less its discount
  getSectionAmount(lineItems: any[]) {
    return lineItems.reduce((sum: number, x: any) => {
      const price = this.jobcard.vatInclusive ? x.unitPrice_IncludingTax : x.unitPrice;
      return sum + +(price * x.quantity).toFixed(2) - (+x.discount?.toFixed(2) || 0);
    }, 0);
  }

  canRejectAll() {
    if (this.jobcard && this.jobcard.jobCardID === undefined) return false;
    var options = this.jobcard.quoteOptions.filter(x => { return x.approvalStatus < 9 });
    return options.length > 0;
  }

  markOptionsAsSeen() {
    var options = this.jobcard.quoteOptions.map(x => {
      return {
        QuoteOptionIdentifier: x.quoteOptionIdentifier
      }
    });
    this.invoiceOptionsService.markApprovalOptionsSeen(this.jobcard.serviceIdentifier, options).subscribe(jobcard => {
    });
  }

  approveQuote(quoteOption) {
    this.busySubmitting = true;

    var data = {
      Options: this.jobcard.quoteOptions.map(x => {
        return {
          QuoteOptionIdentifier: x.quoteOptionIdentifier,
          ApprovalStatus: x.quoteOptionIdentifier === quoteOption.quoteOptionIdentifier ? 10 : 9
        }
      })
    };

    this.invoiceOptionsService.sentApprovalOptions(this.jobcard.serviceIdentifier, data).subscribe(jobcard => {
      this.busySubmitting = false;
      this.jobcard = jobcard;
      this.setSections();
    }, err => {
      this.busySubmitting = false;
    });
  }

  rejectAllOptions() {
    this.displayRejectAll = false;
    this.busySubmitting = true;

    var data = {
      Feedback: this.rejectionFeedback,
      Options: this.jobcard.quoteOptions.map(x => {
        return {
          QuoteOptionIdentifier: x.quoteOptionIdentifier,
          ApprovalStatus: 9
        }
      })
    };

    this.invoiceOptionsService.sentApprovalOptions(this.jobcard.serviceIdentifier, data).subscribe(jobcard => {
      this.busySubmitting = false;
      this.jobcard = jobcard;
      this.setSections();
    }, err => {
      this.busySubmitting = false;
    });
  }

}
